var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import { CenterContent } from "../../center";
import { defaultDropZoneHeight } from "../constants";
/**
 * A component that displays a title, subtitle and an action.
 * This is a generic component that is used to display empty states in the file explorer
 */
export var EmptyState = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, action = _a.action;
    return (_jsx(CenterContent, __assign({ vertical: true, horizontal: true }, { children: _jsxs(Box, __assign({ textAlign: "center", color: "inherit", padding: "xl" }, { children: [_jsx(Box, __assign({ variant: "strong", textAlign: "center", color: "inherit" }, { children: title })), _jsx(Box, __assign({ variant: "p", padding: { bottom: "s" }, color: "inherit" }, { children: subtitle })), action] })) })));
};
/**
 * A component that displays an EmptyState component with a button that clears the filter.
 * This component is rendered when the user filters the table and there are no matches
 */
export var NoMatchEmptyState = function (_a) {
    var clearFilter = _a.clearFilter, i18nStrings = _a.i18nStrings;
    return (_jsx(EmptyState, { title: i18nStrings.noMatchesTitle, subtitle: i18nStrings.noMatchesSubtitle, action: _jsx(Button, __assign({ onClick: clearFilter }, { children: i18nStrings.clearFilter })), i18nStrings: i18nStrings }));
};
/**
 * A component that displays an EmptyState component with a button that clears the filter.
 * This component is rendered when no items are returned from the remote file system
 */
export var NoItemsEmptyState = function (_a) {
    var i18nStrings = _a.i18nStrings, allowedActions = _a.allowedActions;
    // TODO: Make i18nStrings.noUploadAndDownloadPermissionsSubtitle as required field when all teams consume this change.
    // Then the undefined check for subtitle can be removed
    if ((allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.upload) === false &&
        (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.download) === false &&
        (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.noUploadAndDownloadPermissionsSubtitle) !== undefined) {
        return (_jsx(EmptyState, { title: "", subtitle: i18nStrings.noUploadAndDownloadPermissionsSubtitle, action: _jsx(_Fragment, {}), i18nStrings: i18nStrings }));
    }
    else {
        return (_jsx(EmptyState, { title: i18nStrings.noFilesTitle, subtitle: i18nStrings.noFilesSubtitle, action: _jsx(_Fragment, {}), i18nStrings: i18nStrings }));
    }
};
/**
 * This component is rendered when a user is dragging a file or folder on top of the table to indicate that the file or folder can be dropped
 */
export var DropZone = function (_a) {
    var i18nStrings = _a.i18nStrings;
    return (_jsx(CenterContent, __assign({ style: { height: defaultDropZoneHeight }, className: "dropzone_border", vertical: true, horizontal: true }, { children: _jsxs(Box, __assign({ textAlign: "center", color: "inherit", padding: "xl" }, { children: [_jsx(Box, __assign({ variant: "strong", textAlign: "center", color: "inherit" }, { children: i18nStrings.dropZoneTitle })), _jsx(Box, __assign({ variant: "p", padding: { bottom: "s" }, color: "inherit" }, { children: i18nStrings.dropZoneSubtitle }))] })) })));
};
